// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label--Wq9o7suD {\n  display: inline;\n  padding: 4px 10px;\n  border-radius: 6px;\n  line-height: 24px;\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.default--DSc8oniB {\n  padding: 2px 8px;\n}\n\n.error--10Hjpotm {\n  color: #ff0016;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "label--Wq9o7suD",
	"default": "default--DSc8oniB",
	"error": "error--10Hjpotm"
};
export default ___CSS_LOADER_EXPORT___;
